<div #metric class="flex-centered metric w-100">
  <div class="flex-centered value w-100"> <span class="overflow-ellipsis"> {{ data }} </span></div>
  <div class="flex-centered unit w-100"> <span class="overflow-ellipsis"> {{ unit }} </span></div>
</div>
